import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {catchError, Observable} from 'rxjs';
import {GridGetService, GridServiceParams, GridServiceResponse} from 'src/app/shared/model/page-grid';
import {removeEmptyParams} from 'src/infrastructure/helper/remove-empty-params';
import moment from 'moment';
import {AdxSbDailyReconciliation} from '../model/adx-sb-daily-reconciliation';
import {AdxSbReconciliationFilterService} from './adx-sb-reconciliation-filter.service';

@Injectable({
  providedIn: 'root'
})
export class AdxSbDailyGridService implements GridGetService<AdxSbDailyReconciliation> {
  private readonly baseUrl = 'dbov2/adx-sb-reconciliation/daily';
  private readonly http = inject(HttpClient);
  private readonly filterService = inject(AdxSbReconciliationFilterService);

  getItems({page, sort}: GridServiceParams): Observable<GridServiceResponse<AdxSbDailyReconciliation>> {
    const filters = this.filterService.filtersValue();

    const params: Record<string, string | number | boolean> = {
      pageSize: page?.pageSize || 25,
      pageNumber: (page?.pageIndex || 0) + 1,
      propertyName: sort?.active || 'day',
      orderKey: sort?.direction || 'asc',
      from: filters?.From ? moment(filters.From).format('YYYY-MM-DD') : '',
      to: filters?.To ? moment(filters.To).format('YYYY-MM-DD') : '',
      dateBasis: filters?.DateBasis || 'Issue',
    };

    removeEmptyParams(params);

    return this.http.get<GridServiceResponse<AdxSbDailyReconciliation>>(`${this.baseUrl}`, {params: {...params}})
      .pipe(catchError((error: HttpErrorResponse) => {
        throw new Error(error?.message || 'Server error');
      }));
  }
}
